import React from "react";
import type { RichText } from "@shared/arrays/page-common";

/**
 * Renders a copy run that carries inline links. The Tilda exports put links
 * inside sentences; keeping the anchor text in the array is the only way to
 * carry the copy over verbatim without hardcoding it in JSX.
 */
export function Rich({ parts }: { parts: RichText }) {
  return (
    <>
      {parts.map((part, i) =>
        typeof part === "string" ? (
          <React.Fragment key={i}>{part}</React.Fragment>
        ) : (
          <a
            key={i}
            href={part.href}
            {...(part.external
              ? { target: "_blank", rel: "noreferrer noopener" }
              : {})}
          >
            {part.text}
          </a>
        ),
      )}
    </>
  );
}

export default Rich;
